import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SettingsMessage from 'components/settings-message/SettingsMessage';
import CampaignCreate from 'modules/campaigns/components/campaign-create/CampaignCreate';
import CampaignTutorial from '../components/campaign-tutorial/CampaignTutorial';

import { fetchOrganizationSettings } from 'modules/organizations/reducers/organizationSettings';

import { t } from 'utils/language';
import { isBrandSettingsPageInComplete } from 'utils/organization';

import type { OrganizationSettings, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  currentOrganizationId: number,
  organizationSettings: OrganizationSettings
};

type DispatchProps = {
  dispatchFetchOrganizationSettings: (a: number) => Promise<any>
};

type Props = OwnProps & StateProps & DispatchProps;

type State = {
  organizationSettingsLoaded: boolean
};

class CampaignCreatePage extends React.Component<Props, State> {
  state = {
    organizationSettingsLoaded: false
  };

  componentDidMount() {
    const { dispatchFetchOrganizationSettings, currentOrganizationId } = this.props;

    dispatchFetchOrganizationSettings(currentOrganizationId)
      .then(() => this.setState({
        organizationSettingsLoaded: true
      }));
  }

  render(): React.ReactNode {
    const { params, organizationSettings } = this.props;
    const { organizationSettingsLoaded } = this.state;

    if (!organizationSettingsLoaded) {
      return null;
    }

    const steps = [
      { name: 'background' },
      { name: 'creators' },
      { name: 'offers' }
    ];
    const SidebarContent = <CampaignTutorial steps={steps} activeStep="background" />;
    const settingsPageInComplete = isBrandSettingsPageInComplete(organizationSettings);

    return (
      <Page
        documentTitle={t('campaign_create_page')}
      >
        {
          settingsPageInComplete ?
            <SettingsMessage
              organizationId={organizationSettings.id}
              organizationSettings={organizationSettings}
            />
            : (
              <SidebarPage
                align="right"
                sidebarWidth="wide"
                sidebarContent={SidebarContent}
                sidebarMarginTop={84}
              >
                <CampaignCreate profileId={Number(params.id)} />
              </SidebarPage>
            )
        }
      </Page>
    );
  }
}

const mapStateToProps = ({ organizations, organizationSettings }): StateProps => ({
  currentOrganizationId: organizations.currentOrganizationId,
  organizationSettings: organizationSettings.organization
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchOrganizationSettings: (organizationId: number) => dispatch(fetchOrganizationSettings(organizationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCreatePage);
